<template>
  <div>
    <div v-if="item && order">
      <h3>{{ item.name }}</h3>
      <h5>
        {{ "price" | setText("Цена") }}: {{ price | spaceBetweenNumber }} UZS
      </h5>
      <hr />
      <ul v-if="item.conditionals.length">
        <li v-for="(cond, key) in item.conditionals" :key="key">
          <h5>
            Срок: {{ cond.month }} {{ "mo" | setText("мес.") }} -
            <span class="badge badge-danger">
              ~
              {{
                Math.round(
                  (price + (price * cond.coefficient) / 100) / cond.month
                ) | spaceBetweenNumber
              }}
              UZS / {{ "mo" | setText("мес.") }}
            </span>
          </h5>
        </li>
      </ul>
      <h6 v-else>{{ "no_conditional" | setText("Нет условий") }}</h6>
    </div>
    <h4 v-else>
      {{ "wait_callculating" | setText("Ожидайте - идет расчет...") }}
    </h4>
  </div>
</template>

<script>
import { cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    item: null,
    order: null,
    price: 0,
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.$loading(true);
    this.item = await this.cardContent(`partners`, this.partner_id);
    this.order = await this.cardContent(`orders`, this.order_id);
    this.price = this.order.price_total;
    this.$loading(false);
  },
  methods: {
    cardContent: cardContent,
  },
  computed: {
    partner_id: {
      get() {
        return this.id.split("-")[0] ? this.id.split("-")[0] : null;
      },
    },
    order_id: {
      get() {
        return this.id.split("-")[1] ? this.id.split("-")[1] : null;
      },
    },
  },
};
</script>
<style>
</style>
